import React from 'react'
import { Link } from 'react-router-dom'
import Footer from './components/footer/Footer'
import Topbar from './components/Topbar/Topbar'
function ErrorPage() {
    return (
        <div>
            <Topbar color='#FF3D00' page='property' />
            <section style={{backgroundImage:"url(https://roomph.ascendant.travel/images/404-bg1.jpg)"}} className="error">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center my-5">
                            <img src="https://roomph.ascendant.travel/images/error-img.png" className="img-fluid mx-auto mt-5" />
                        </div>
                        <div className="col-12 text-center mb-5">
                            <h3 className="text-white">Sorry...</h3>
                            <p className="text-white mb-4">Looks like this&nbsp;page&nbsp;found a great room and is no longer here.</p>
                            <p className="text-white">Try your luck in one of our featured destinations:</p>
                            <Link to="/"  className='text-white f-18 mt-3'><u>Go back to home page</u></Link>
                        </div>
                    </div>

                </div>

            </section>
            <Footer />
        </div>
    )
}

export default ErrorPage
